"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isInteger2 = _interopRequireDefault(require("lodash/isInteger"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Avatar = _interopRequireDefault(require("../../Clients/Avatar"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Count = _interopRequireDefault(require("../../Common/Count"));
var _Name = _interopRequireDefault(require("../../Clients/Name"));
var _TagList = _interopRequireDefault(require("../../Tags/TagList"));
var _TicketId = _interopRequireDefault(require("../TicketId"));
var _TicketStatus = _interopRequireDefault(require("../TicketStatus"));
var _TicketType = _interopRequireWildcard(require("../TicketType"));
var _constants = require("../TicketStatus/constants");
var _iconsReact = require("../../../../icons-react");
var _excluded = ["manager", "ticket", "onSelect", "getOrderURLById"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var avatarPropTypes = _Avatar["default"].propTypes;
var nameType = avatarPropTypes.name,
  avatarUrlType = avatarPropTypes.url;
var tagListPropTypes = _TagList["default"].propTypes;
var tagsPropTypes = tagListPropTypes.tags;
var TicketStatusPropTypes = _TicketStatus["default"].propTypes;
var TicketCardWithManager = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var manager = _ref.manager,
    ticket = _ref.ticket,
    onSelect = _ref.onSelect,
    getOrderURLById = _ref.getOrderURLById,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!ticket) {
    return null;
  }
  var id = ticket.id,
    subject = ticket.subject,
    subtype = ticket.subtype,
    subAgentName = ticket.subAgentName,
    status = ticket.status,
    tags = ticket.tags,
    type = ticket.type,
    unreadAmount = ticket.unreadAmount,
    orderIds = ticket.orderIds;
  var priority = status.priority,
    time = status.time,
    title = status.title;
  var isValidCount = (0, _isInteger2["default"])(unreadAmount) && unreadAmount > 0;
  var onClickHandler = (0, _react.useCallback)(function () {
    return onSelect(ticket.id);
  }, [ticket]);
  var managerComponent = null;
  if (manager) {
    var avatarUrl = manager.avatarUrl,
      fullName = manager.fullName,
      number = manager.number;
    managerComponent = /*#__PURE__*/_react["default"].createElement(StyledManager, null, /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
      name: fullName,
      url: avatarUrl
    }), /*#__PURE__*/_react["default"].createElement(StyledName, {
      name: fullName
    }), number && /*#__PURE__*/_react["default"].createElement(StyledNumber, null, number));
  }
  return /*#__PURE__*/_react["default"].createElement(StyledTicketCardWithManager, (0, _extends2["default"])({
    functional: true,
    onClick: onClickHandler
  }, props), /*#__PURE__*/_react["default"].createElement(_TicketId["default"], {
    id: "\u0422\u0438\u043A\u0435\u0442 ".concat(id)
  }), /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledTicketType, {
    subtype: subtype,
    type: type
  }), /*#__PURE__*/_react["default"].createElement(StyledCountContainer, null, isValidCount && /*#__PURE__*/_react["default"].createElement(_Count["default"], {
    value: unreadAmount
  }))), /*#__PURE__*/_react["default"].createElement(StyledSubject, {
    title: subject
  }, subject), /*#__PURE__*/_react["default"].createElement(StyledStatus, {
    priority: priority,
    time: time,
    title: title,
    placement: _constants.TICKET_STATUS_PLACEMENT.TICKET_CARD_WITH_MANAGER
  }), managerComponent, !!subAgentName && /*#__PURE__*/_react["default"].createElement(StyledSubAgentName, null, subAgentName), /*#__PURE__*/_react["default"].createElement(StyledTags, {
    tags: tags,
    title: ((0, _isArray2["default"])(tags) ? tags : []).join(', ')
  }), (0, _isArray2["default"])(orderIds) && orderIds.map(function (orderId) {
    return /*#__PURE__*/_react["default"].createElement(StyledOrderLink, {
      onClick: function onClick(event) {
        event.stopPropagation();
      },
      href: getOrderURLById(orderId),
      target: "_blank",
      rel: "noopener noreferrer",
      key: orderId
    }, /*#__PURE__*/_react["default"].createElement(StyledOrderArrow, null), "\u0417\u0430\u043A\u0430\u0437: ", orderId);
  }));
});
TicketCardWithManager.displayName = 'TicketCardWithManager';
TicketCardWithManager.propTypes = {
  className: _propTypes["default"].string,
  manager: _propTypes["default"].shape({
    avatarUrl: avatarUrlType.isRequired,
    fullName: nameType.isRequired,
    number: _propTypes["default"].number
  }),
  ticket: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    subject: _propTypes["default"].string.isRequired,
    subtype: _propTypes["default"].oneOf(Object.values(_TicketType.SUBTYPES)),
    status: _propTypes["default"].shape(TicketStatusPropTypes).isRequired,
    tags: tagsPropTypes.isRequired,
    type: _propTypes["default"].oneOf(Object.values(_TicketType.TYPES)).isRequired,
    unreadAmount: _propTypes["default"].number
  }).isRequired,
  onSelect: _propTypes["default"].func
};
TicketCardWithManager.defaultProps = {
  className: '',
  manager: null,
  onSelect: Function.prototype
};
var StyledTicketCardWithManager = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TicketCardWithManager__StyledTicketCardWithManager",
  componentId: "sc-pd6m5h-0"
})(["background-color:#f5f3f2;border-radius:2px;display:flex;flex-direction:column;height:136px;padding:6px 10px;width:100%;"]);
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TicketCardWithManager__StyledWrapper",
  componentId: "sc-pd6m5h-1"
})(["display:flex;justify-content:space-between;* + &{margin-top:7px;}"]);
var StyledTicketType = (0, _styledComponents["default"])(_TicketType["default"]).withConfig({
  displayName: "TicketCardWithManager__StyledTicketType",
  componentId: "sc-pd6m5h-2"
})(["margin-right:12px;"]);
var StyledCountContainer = _styledComponents["default"].div.withConfig({
  displayName: "TicketCardWithManager__StyledCountContainer",
  componentId: "sc-pd6m5h-3"
})(["width:23px;"]);
var StyledSubject = _styledComponents["default"].div.withConfig({
  displayName: "TicketCardWithManager__StyledSubject",
  componentId: "sc-pd6m5h-4"
})(["color:#17181a;font-size:14px;font-weight:700;line-height:17px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%;text-align:left;* + &{margin-top:3px;}"]);
var StyledStatus = (0, _styledComponents["default"])(_TicketStatus["default"]).withConfig({
  displayName: "TicketCardWithManager__StyledStatus",
  componentId: "sc-pd6m5h-5"
})(["font-size:14px;text-align:left;"]);
var StyledOrderLink = _styledComponents["default"].a.withConfig({
  displayName: "TicketCardWithManager__StyledOrderLink",
  componentId: "sc-pd6m5h-6"
})(["font-size:12px;line-height:16px;color:#007aff;z-index:10;"]);
var StyledOrderArrow = (0, _styledComponents["default"])(_iconsReact.ArrowUpRight).withConfig({
  displayName: "TicketCardWithManager__StyledOrderArrow",
  componentId: "sc-pd6m5h-7"
})(["width:9px;height:8px;display:inline-block;margin-right:4px;"]);
var StyledManager = _styledComponents["default"].div.withConfig({
  displayName: "TicketCardWithManager__StyledManager",
  componentId: "sc-pd6m5h-8"
})(["color:#4d4d4d;display:flex;font-size:14px;* + &{margin-top:8px;}"]);
var StyledAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "TicketCardWithManager__StyledAvatar",
  componentId: "sc-pd6m5h-9"
})(["height:18px;width:18px;"]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "TicketCardWithManager__StyledName",
  componentId: "sc-pd6m5h-10"
})(["font-weight:normal;* + &{margin-left:7px;}"]);
var StyledNumber = _styledComponents["default"].div.withConfig({
  displayName: "TicketCardWithManager__StyledNumber",
  componentId: "sc-pd6m5h-11"
})([":before{content:'\u22C5';margin:0 5px;}"]);
var StyledTags = (0, _styledComponents["default"])(_TagList["default"]).withConfig({
  displayName: "TicketCardWithManager__StyledTags",
  componentId: "sc-pd6m5h-12"
})(["color:#919499;display:block;font-size:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%;text-align:left;"]);
var StyledSubAgentName = _styledComponents["default"].div.withConfig({
  displayName: "TicketCardWithManager__StyledSubAgentName",
  componentId: "sc-pd6m5h-13"
})(["font-size:13px;font-weight:700;color:#4b137b;margin:5px 0;"]);
TicketCardWithManager.PRIORITIES = _constants.PRIORITIES;
TicketCardWithManager.TYPES = _TicketType.TYPES;
var _default = exports["default"] = TicketCardWithManager;